module.exports = __webpack_public_path__ + "static/selling_marketing_services-58cf069c8e478f22a02d4a33ca786a41.svg";